<template>
  <div class="modal fade" id="Delete" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-12 my-auto">
            <span>
              <a class="close">
                <i
                  class="far fa-times-circle fa-2x"
                  data-dismiss="modal"
                  id="closeDeleteBill"
                  aria-label="Close"
                ></i>
              </a>
            </span>
          </div>
        </div>
        <div class="container-fluid">
          <!-- <form @submit.prevent="confirmDeleteBill"> -->
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row text-center mt-3">
                <div class="col-sm-12">
                  <p class="font-weight-bold">Are you sure you want to delete this bill?</p>
                </div>
                <div class="col-sm-12 no-pad">
                  <button
                    id="confirmDeleteBill"
                    type="submit"
                    class="btn btn-hc w-40 mr-2 mb-3"
                    :disabled="submitStatus === 'PENDING'"
                    @click="confirmDeleteBill"
                  >Yes</button>
                  <button
                    id="cancelDeleteBill"
                    type="submit"
                    class="btn btn-hc w-40 ml-2 mb-3"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="document.getElementById('closeDeleteBill').click()"
                  >No</button>
                </div>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Mixins
import snotifyHttpError from "@/mixins/snotifyHttpResponses";

export default {
  mixins: [snotifyHttpError],
  data() {
    return {
      submitStatus: null,
    };
  },
  computed: {
    details() {
      return this.$store.state.finances.billDetails;
    },
  },
  methods: {
    async confirmDeleteBill() {
      this.submitStatus = "PENDING";
      document.getElementById("closeDeleteBill").click();

      // Create a promise for the submit method that can be passed to $snotify.async separately
      let submit = new Promise((resolve, reject) => {
        this.submit(resolve, reject);
      });

      // Pass the submit promise to snotify to show async component
      this.$snotify.async("Deleting bill...", () => submit);
      await submit;
    },

    async submit(resolve, reject) {
      try {
        // Below line will throw any http errors.
        let response = await this.$store.dispatch("deleteBill");
        this.submitStatus = "OK";

        // Update Vuex state
        // Below could possibly be in a finally block
        this.$store.dispatch("getLedger");
        this.$store.dispatch("getCharges");
        this.$store.dispatch("getUsage");
        this.$store.dispatch("refreshReadings");
        this.$store.dispatch("getBills");
        this.$store.dispatch("refreshCustomer");

        if (response.data.Processed.length > 0) {
          resolve({
            body: "Success! Bill deleted!",
            config: {
              closeOnClick: true,
              timeout: 2000,
            },
          });
        } else {
          reject({
            body: "Unable to delete bill!",
            config: {
              closeOnClick: true,
              timeout: 2000,
            },
          });
        }
      } catch (error) {
        // Parses http error and rejects
        reject(this.snotifyHttpError(error));
      }
    },
  },
};
</script>